import { ArrowIcon } from "./ArrowIcon";
import { CREATE_ACCOUNT_HREF } from "./constants";
import {
  ActionLink,
  Hero,
  HeroCopy,
  HeroDescription,
  ManualNote,
} from "./styles";

export function WelcomeHero() {
  return (
    <Hero>
      <HeroCopy>
        <h1>
          Know where you stand. <br />
          <em>See what’s changing.</em>
        </h1>
      </HeroCopy>
      <HeroDescription>
        <p>
          Your accounts, daily spending, investments, and savings. Bring them
          together to answer the questions that matter to you.
        </p>
        <ActionLink as="a" href={CREATE_ACCOUNT_HREF}>
          Create your account <ArrowIcon />
        </ActionLink>
        <ManualNote>Manual tracking. No bank connection required.</ManualNote>
      </HeroDescription>
    </Hero>
  );
}
